export function isTelegramEnv(): boolean {
  if (typeof window === 'undefined') return false;
  const tg = (window as any).Telegram?.WebApp;
  return Boolean(tg?.initData || tg?.initDataUnsafe?.user);
}
